// src/components/WeeklyQuestion.js
// Gold+ members answer Sky Bri's weekly question
// Sky Bri replies from admin panel
import { useState, useEffect } from 'react'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'
import './WeeklyQuestion.css'

export default function WeeklyQuestion() {
  const { session } = useAuth()
  const userId = session?.user?.id
  const [question, setQuestion] = useState(null)
  const [myResponse, setMyResponse] = useState(null)
  const [input, setInput] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    if (!userId) return
    fetchQuestion()
  }, [userId])

  async function fetchQuestion() {
    // Get active question
    const { data: q } = await supabase
      .from('weekly_questions')
      .select('*')
      .eq('active', true)
      .order('created_at', { ascending: false })
      .limit(1)
      .single()

    if (!q) return
    setQuestion(q)

    // Check if user already responded
    const { data: resp } = await supabase
      .from('question_responses')
      .select('*')
      .eq('question_id', q.id)
      .eq('user_id', userId)
      .single()

    if (resp) { setMyResponse(resp); setSubmitted(true) }
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (!input.trim() || !question) return
    setSubmitting(true)

    const { data, error } = await supabase
      .from('question_responses')
      .insert({
        question_id: question.id,
        user_id: userId,
        response: input.trim()
      })
      .select()
      .single()

    setSubmitting(false)
    if (error) return
    setMyResponse(data)
    setSubmitted(true)
    setInput('')
  }

  if (!question) return null

  return (
    <div className="wq">
      <div className="wq__header">
        <span className="wq__eyebrow">This Week</span>
        <h3 className="wq__title">Sky Bri Wants to Know</h3>
      </div>

      <div className="wq__question">
        <span className="wq__q-mark">"</span>
        <p className="wq__q-text">{question.question}</p>
      </div>

      {!submitted ? (
        <form onSubmit={handleSubmit} className="wq__form">
          <textarea
            className="wq__input"
            placeholder="Share your honest answer..."
            value={input}
            onChange={e => setInput(e.target.value)}
            rows={3}
            maxLength={500}
          />
          <div className="wq__form-footer">
            <span className="wq__char-count">{input.length}/500</span>
            <button
              className="btn btn--gold btn--sm"
              type="submit"
              disabled={submitting || !input.trim()}
            >
              {submitting ? 'Sending...' : 'Send to Sky Bri'}
            </button>
          </div>
        </form>
      ) : (
        <div className="wq__submitted">
          <div className="wq__my-response">
            <p className="wq__my-label">Your answer</p>
            <p className="wq__my-text">{myResponse?.response}</p>
          </div>

          {myResponse?.sky_reply ? (
            <div className="wq__sky-reply">
              <div className="wq__sky-avatar">S</div>
              <div>
                <p className="wq__sky-label">Sky Bri replied</p>
                <p className="wq__sky-text">{myResponse.sky_reply}</p>
              </div>
            </div>
          ) : (
            <div className="wq__waiting">
              <div className="wq__waiting-dot" />
              Sky Bri will reply soon
            </div>
          )}
        </div>
      )}
    </div>
  )
}
